<template lang="pug">
    div
        Icon.blink(:type="type" :size="size", :color="color")
</template>
<script>
export default {
    name: "BlinkingIcon",
    props: {
        type: { required: true },
        size: {
            default: 24
        },
        color: {
            default: "black"
        }
    },
    components: {},
    watch: {},
    created() {},
    data() {
        return {};
    },
    methods: {},
    mounted() {},
    computed: {},
    filters: {}
};
</script>
<style scoped>
.blink {
    animation: blinker 1s linear infinite;
}

@keyframes blinker {
    50% {
        opacity: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/BlinkingIcon.vue